import { render, staticRenderFns } from "./result_sentence.vue?vue&type=template&id=7d697fe2&scoped=true&"
import script from "./result_sentence.vue?vue&type=script&lang=js&"
export * from "./result_sentence.vue?vue&type=script&lang=js&"
import style0 from "./result_sentence.vue?vue&type=style&index=0&id=7d697fe2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d697fe2",
  null
  
)

export default component.exports